module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/gifs/email-integration-1-start.gif"